import { OccasionsEnum } from './bundles.types';

export enum PricingTypeEnum {
  'PERCENT_OFF_PROMOTION' = 'PercentOffPromotion',
  'AMOUNT_OFF_PROMOTION' = 'AmountOffPromotion',
  'FIXED_PRICE_PROMOTION' = 'FixedPricePromotion',
  'VARIABLE_PERCENT_OFF_PROMOTION' = 'VariablePercentOffPromotion',
  'VARIABLE_AMOUNT_OFF_PROMOTION' = 'VariableAmountOffPromotion',
  'VARIABLE_FIXED_PRICE_PROMOTION' = 'VariableFixedPricePromotion',
}

export enum EffectTypeNameEnum {
  'OrderLevelPromotionEffect' = 'Order Level',
  'BelowLineItemPromotionEffect' = 'Below Line Item',
  'ItemLevelPromotionEffect' = 'Item Level',
}

export enum EffectPricingTypeNameEnum {
  'PercentOffPromotion' = 'Percent Off',
  'AmountOffPromotion' = 'Amount Off',
  'FixedPricePromotion' = 'Fixed Price',
  'VariablePercentOffPromotion' = 'Variable Percent Off',
  'VariableAmountOffPromotion' = 'Variable Amount Off',
  'VariableFixedPricePromotion' = 'Variable Fixed Price',
}

export interface Effect {
  typeName: string;
  pricingTypeName: string;
  percentage: number;
  amount: number;
  maximumPercentage: number;
  minimumPercentage: number;
  maximumAmount: number;
  minimumAmount: number;
  maximumFixedPrice: number;
  minimumFixedPrice: number;
  options: string;
}

export interface PromotionStatusGroup {
  storeGroup: string;
  status: string;
  groupId: string;
}

//mock Data
export interface PromotionData {
  promotionId: string;
  name: string;
  displayName: string;
  description: string;
  occasions: OccasionsEnum[];
  activeStoreCount: number;
  combinable: boolean;
  maxUses: number;
  isVisible: boolean;
  isLock: boolean;
  promotionStatusGroup: PromotionStatusGroup[];
  isAllLock?: boolean;
}

export interface PromotionDetails extends Omit<PromotionData, 'combinable'> {
  effects: Effect[];
  redemptionCodes: string[];
  type: string;
  isCombinable: boolean;
}

export interface GroupAndStatus {
  storeGroup: string;
  status: string;
  groupId: string;
  isHidden?: boolean;
}

export interface Promotion {
  promotionId: string;
  name: string;
  displayName: string;
  occasions: OccasionsEnum[];
  redemptionCodes: string[];
  activeStoreCount: number;
  description: string;
  isVisible: boolean;
  isLock: boolean;
  isCombinable: boolean;
  maxUses: number;
  legalText?: string;
  effects: Effect[];
  promotionStatusGroup: GroupAndStatus[];
}

export interface PromoSelection {
  promotionId: string;
  isLock: boolean;
}

export interface DeactivatePromotionPayload {
  promotionIds: string[];
  addStoreGroupsIds: string[];
  removeStoreGroupsIds: string[];
}

export interface PromotionReport {
  exportDate: string;
  storeNumber: string;
  storeGroup: string;
  promotionName: string;
  promotionId: string;
  status: string;
}
